/** Placeholder shown in table cells whose value is null/empty. */
export const EmptyValueText = '-';

/** Value a boolean filter takes on the URL once `qs` has stringified it. */
export const TrueParamValue = 'true';

/** Upper bound checked on the client before uploading an import file. */
export const MaxImportFileSizeMb = 10;

/** Extensions accepted by the account import screen. */
export const ImportFileExtensions = ['.xls', '.xlsx'] as const;

/** `accept` attribute of the import file picker, built from the accepted extensions. */
export const ImportFileAccept = ImportFileExtensions.join(',');

/** Formats line shown under the import drop zone. */
export const ImportSupportedTypesLabel = 'Hỗ trợ .xls, .xlsx';

export const ImportDropZoneLabel = 'Kéo thả file Excel hoặc';

/** File name used when saving the downloaded import template. */
export const ImportTemplateFileName = 'template-tai-khoan.xlsx';

/** `POST /users` always creates a regular account, never a system admin. */
export const IsAdminDefault = false;

/** Role preselected when creating an account. */
export const DefaultUserRole = 'USER';

export const AssignableRolePrefixes = ['EOFFICE_'] as const;
export const AssignableRoleNames = [DefaultUserRole, 'DIGITAL_SIGN'] as const;

const HttpStatusUnauthorized = 401;
const HttpStatusForbidden = 403;

/**
 * Statuses of a failed `GET /user/me` that the axios interceptor already owns: 401 triggers the token
 * refresh + retry, 403 redirects to the forbidden page. Every other failure ends the session.
 */
export const CurrentUserErrorStatusesHandledByInterceptor = [
  HttpStatusUnauthorized,
  HttpStatusForbidden,
] as const;
